import GrowthEventsComponent from '../Components/Growth/GrowthEventsComponent';

function GrowthEventsPage() {
  return <GrowthEventsComponent />;
}

export default GrowthEventsPage;